import MarketingNav from "@/components/MarketingNav";
import MarketingFooter from "@/components/MarketingFooter";

export default function Accessibility() {
  return (
    <div className="bg-[#fbfcfc] min-h-screen">
      <MarketingNav />
      <section className="bloq-section">
        <div className="bloq-container max-w-3xl">
          <p className="bloq-eyebrow">Accessibility</p>
          <h1 className="bloq-display text-5xl mt-3 mb-3">Built to be usable by everyone</h1>
          <p className="text-sm text-[#82828c] mb-12">Last updated: Feb 2026</p>
          <div className="text-[#4a4a52] leading-relaxed flex flex-col gap-5">
            <p>
              We design Bloq with WCAG 2.2 AA as the baseline. The product is built with semantic
              HTML, ARIA where it improves screen-reader output, full keyboard navigation, visible
              focus states, color contrast ≥ 4.5:1 for body text, and resilient component patterns
              from Radix UI.
            </p>
            <h3 className="text-[#1a1a1f] font-semibold text-lg">What works today</h3>
            <ul className="list-disc pl-5 flex flex-col gap-1.5">
              <li>Full keyboard navigation across the app</li>
              <li>Color contrast tested against WCAG AA</li>
              <li>Captions-ready video architecture (Agora supports live captions)</li>
              <li>Skip-to-content and proper heading hierarchy on marketing pages</li>
            </ul>
            <h3 className="text-[#1a1a1f] font-semibold text-lg">What's coming</h3>
            <ul className="list-disc pl-5 flex flex-col gap-1.5">
              <li>Live captions in meetings (Q2 2026)</li>
              <li>High-contrast theme</li>
              <li>Reduced-motion preference respected by all animations</li>
            </ul>
            <p>
              Spotted something we missed? Email <strong>access@bloq.video</strong>. We treat accessibility issues as bugs of the highest priority.
            </p>
          </div>
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}
